import {
  TicketListGeneric,
  TicketEditGeneric,
  TicketCreateGeneric,
  TicketShowGeneric,
  TicketListDraftGeneric,
} from './tickets_generic'

export const TicketList = (props) => (
  <TicketListGeneric {...props} title="Dossiers" />
)

export const TicketListDraft = (props) => (
  <TicketListDraftGeneric
    {...props}
    filter={{ archived: 'false' }}
    title="Dossiers"
  />
)

export const TicketEdit = (props) => {
  return <TicketEditGeneric {...props} />
}

export const TicketCreate = (props) => {
  return <TicketCreateGeneric {...props} />
}

export const TicketShow = (props) => {
  return <TicketShowGeneric {...props} />
}
